<template>
  <div class="integration-box">
    <div class="d-flex align-items-center flex-wrap">
      <img :src="require('@/assets/samsara.svg')" />
      <button v-if="status" type="button"
        class="btn btn-primary export equipment ml-0 ml-sm-4 mt-2 mt-sm-0 h-40px w-100px">
        {{ $t('samsara.active') }}
      </button>
      <button v-else type="button" class="h-40px btn btn-secondary close-btn ml-4 mt-2 mt-sm-0">
        {{ $t('samsara.inactive') }}
      </button>
    </div>
    <p class="mt-3 text-tertiary">
      {{ $t('samsara.description') }}
    </p>
    <div v-if="status">
      <div
        class="d-flex align-items-center flex-wrap mb-3"
        v-for="(item, index) in buttonsData"
        :key="index"
      >
        <div>
          <p class="mb-0">{{ $t(item.titleKey) }}</p>
          <button
            @click="setSyncData(item.link)"
            type="button"
            :disabled="item.status === true ? false : true"
            class="h-40px btn btn-primary export equipment mt-2 w-100px text-white"
          >
            {{ $t('samsara.syncData') }}
          </button>
        </div>
      </div>
    </div>
    <div class="d-flex gap-3 align-items-center justify-content-between buttons-section flex-wrap">
      <div>
        <div v-if="status" class="d-flex align-items-center">
          <b-button type="button" class="w-130px h-40px" variant="danger" @click="removeSamsaraToken()">
            {{ $t('samsara.deactivate') }}
          </b-button>
          <b-button type="button" class="w-130px h-40px ml-3" variant="outline-primary"
            @click="$bvModal.show('samsara-tile-modal')">
            {{ $t('samsara.tileUrl') }}
          </b-button>
          <b-button type="button" class="w-130px h-40px ml-3" variant="outline-primary"
            @click="$bvModal.show('samsara-invite-drivers-modal')">
            {{ $t('samsara.inviteDrivers') }}
          </b-button>
        </div>
        <button v-else
          class="border-0 btn btn-success assigned-equipment w-100px h-40px d-flex align-items-center justify-content-center"
          @click="activateSamsara()">{{ $t('samsara.activate') }}</button>
      </div>
      <button type="button" class="btn btn-secondary close-btn w-100px h-40px" @click="$emit('close')">
        {{ $t('samsara.close') }}
      </button>
    </div>
    <SamsaraTile />
    <SamsaraInviteDrivers />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SamsaraTile from "./SamsaraTile.vue";
import SamsaraInviteDrivers from "./SamsaraInviteDrivers.vue";
export default {
  name: "Samsara-Integration",
  props: ["status"],
  components: { SamsaraTile, SamsaraInviteDrivers },
  data() {
    return {
      buttonsData: [
        {
          titleKey: "samsara.vehicles",
          link: "samsara_vehicle_sync",
          status: true,
          data: "Vehicle",
        },
        {
          titleKey: "samsara.trailers",
          link: "samsara_trailer_sync",
          status: true,
          data: "Trailer",
        },
        {
          titleKey: "samsara.drivers",
          link: "samsara_driver_sync",
          status: true,
          data: "Driver",
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setLoader",
      "setNotification",
      "setAssetsData",
      "getAssetsData",
      "updateCompany"
    ]),
    activateSamsara() {
      if (this.company[0].default_password) {
        window.open("https://api.samsara.com/oauth2/authorize?client_id=6a219b27a54f49a0bc923dfd6994245c&state=z3qAr0h5Ud&response_type=code")
      }
      else {
        this.$bvModal.show('modal-set-password-default-drivers')
      }
    },
    async setSyncData(link) {
      try {
        this.setLoader(true);
        await this.setAssetsData(link);
        await this.setNotification({
          msg: this.$t('samsara.syncSuccess'),
          type: "success",
          color: "green",
        });
        this.setLoader(false);
      } catch (error) {
        this.setLoader(false);
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    setButtonsData() {
      if (
        this.assetsData.filter((item) => item.partner_name === "Samsara")
          .length === 0
      )
        this.buttonsData[2].status = false;
    },
    async removeSamsaraToken() {
      try {
        delete this.company[0].logo
        await this.updateCompany({
          id: this.userCompany,
          payload: { ...this.company[0], samsara_refreshtoken: "", samsara_cron_last_synced: null, samsara_access_token: "", samsara_access_token_expiry: null, state: this.company[0].state.id },
        });
        await this.setNotification({
          msg: this.$t('samsara.removeSuccess'),
          type: "success",
          color: "green",
        });
      }
      catch (e) {
        console.log(e)
      }
    }
  },
  computed: {
    ...mapGetters(["assetsData", "company", 'userCompany']),
  },
  mounted() { },
};
</script>
<style>
.copy-samsara-link {
  position: absolute;
  right: 16px;
  top: 60%;
  cursor: pointer;
  z-index: 1;
}
</style>
